<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item v-for="route in permission_routers" :key="route.name" :item="route" :base-path="route.path"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import store from "@/store";
export default {
  components: { SidebarItem },
  data() {
    return {
      businessType: store.getters.user.businessType
    };
  },
  computed: {
    ...mapGetters(["permission_routers", "sidebar"]),
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  created() {
    if (this.businessType) {
      this.permission_routers.forEach(item => {
        if (item.name === "System") {
          item.children = item.children.filter(
            item2 =>
              item2.name != "SystemFunctions" &&
              item2.name != "SystemDictionaryList" &&
              item2.name != "SystemIdentify"
          );
        }
        if (item.name === "Vehicle") {
          item.children = item.children.filter(
            item2 => item2.name != "Series30List"
          );
        }
      });
    }
  }
};
</script>
